export default __webpack_public_path__ + "static/media/splitsmart-logo.06cca383.png";